import React from 'react'

export function FlagIcon() {
  return (
    <svg width="18" height="24" viewBox="0 0 18 24" fill="none">
      <path d="M17.0918 3.55861L13.9586 7.75997L17.0718 11.941C17.1968 12.1088 17.2164 12.3328 17.1225 12.5198C17.0286 12.7068 16.8373 12.8249 16.628 12.8249H3.1583V22.3285H3.85978C4.16536 22.3285 4.41314 22.5763 4.41314 22.8819C4.41314 23.1875 4.16536 23.4352 3.85978 23.4352H1.35023C1.04466 23.4352 0.796875 23.1875 0.796875 22.8819C0.796875 22.5763 1.04466 22.3285 1.35023 22.3285H2.05153V0.5625L3.15834 0.562547V2.67441H16.6481C16.8575 2.67441 17.0489 2.79253 17.1428 2.97966C17.2367 3.16678 17.2169 3.39084 17.0918 3.55861Z" stroke="#6C757D"/>
    </svg>
  )
}